<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.94977 6.99993L0 11.9497L1.41421 13.3639L6.36398 8.41414L11.3138 13.3639L12.728 11.9497L7.7782 6.99993L12.7279 2.0502L11.3137 0.635986L6.36398 5.58571L1.41426 0.635986L4.44651e-05 2.0502L4.94977 6.99993Z" fill="#2C4F26"/>
</svg>
